import { InputAdornment } from '@mui/material';
import { array, object, string } from 'yup';

import { RHFAutocomplete, RHFDatePicker, RHFRadioGroup, RHFReactNumberFormat, RHFTextField } from '@zeta-core';

export const liabilitiesValidations = object().shape({
  id: string(),
  liabilityType: string(),
  institution: string(),
  originalAmount: string(),
  monthlyPayment: string(),
  paymentFrequency: string(),
  startDate: string(),
  endDate: string(),
  interest: string(),
  currentValue: string(),
  collateral: string(),
  securedOrNot: string(),
  description: string(),
});

export const liabilitiesValidationSchema = object().shape({
  client: array().of(liabilitiesValidations),
  partner: array().of(liabilitiesValidations),
  joint: array().of(liabilitiesValidations),
});

export const liabilitiesDefault = (ffConfig) => [
  {
    liabilityType: 'Mortgage',
    institution: '',
    originalAmount: 0,
    monthlyPayment: 0,
    paymentFrequency: '',
    startDate: '',
    endDate: '',
    interest: '',
    currentValue: 0,
    collateral: '',
    securedOrNot: '',
    description: '',
    show: ffConfig?.fields?.mortgage?.active ?? true,
  },
  {
    liabilityType: 'Personal Loans',
    institution: '',
    originalAmount: 0,
    monthlyPayment: 0,
    paymentFrequency: '',
    startDate: '',
    endDate: '',
    interest: '',
    currentValue: 0,
    collateral: '',
    securedOrNot: '',
    description: '',
    show: ffConfig?.fields?.personalloans?.active ?? true,
  },
  {
    liabilityType: 'Credit Card',
    institution: '',
    originalAmount: 0,
    monthlyPayment: 0,
    paymentFrequency: '',
    startDate: '',
    endDate: '',
    interest: '',
    currentValue: 0,
    collateral: '',
    securedOrNot: '',
    description: '',
    show: ffConfig?.fields?.creditcard?.active ?? true,
  },
  {
    liabilityType: 'Car Loan',
    institution: '',
    originalAmount: 0,
    monthlyPayment: 0,
    paymentFrequency: '',
    startDate: '',
    endDate: '',
    interest: '',
    currentValue: 0,
    collateral: '',
    securedOrNot: '',
    description: '',
    show: ffConfig?.fields?.carloan?.active ?? true,
  },
];

export const liabilitiesDefaultValues = (ffConfig) => {
  return { client: liabilitiesDefault(ffConfig), partner: liabilitiesDefault(ffConfig), joint: liabilitiesDefault(ffConfig) };
};

export const LIABILITY_TABLE_STRUCTURE = (frequencyOptions) => {
  return [
    { label: 'Liability Type', name: 'liabilityType', component: RHFTextField, minWidth: 150, width: 150, show: true },
    { label: 'Institution', name: 'institution', component: RHFTextField, minWidth: 150, width: 150, show: true },
    {
      label: 'Original Amount',
      name: 'originalAmount',
      component: RHFReactNumberFormat,
      decimalScale: 2,
      thousandSeparator: true,
      fixedDecimalScale: true,
      textAlign: 'right',
      prefix: true,
      minWidth: 150,
      width: 150,
      show: true,
    },
    {
      label: 'Monthly Payment',
      name: 'monthlyPayment',
      component: RHFReactNumberFormat,
      decimalScale: 2,
      thousandSeparator: true,
      fixedDecimalScale: true,
      textAlign: 'right',
      prefix: true,
      minWidth: 150,
      width: 150,
      show: true,
    },
    {
      label: 'Payment Frequency',
      name: 'paymentFrequency',
      component: RHFRadioGroup,
      options: frequencyOptions,
      row: true,
      minWidth: 470,
      width: 470,
      show: true,
    },
    { label: 'Start Date', name: 'startDate', component: RHFDatePicker, minWidth: 200, width: 200, show: true },
    { label: 'End Date', name: 'endDate', component: RHFDatePicker, minWidth: 200, width: 200, show: true },
    {
      label: 'Interest',
      name: 'interest',
      component: RHFReactNumberFormat,
      minWidth: 70,
      width: 70,
      textAlign: 'right',
      decimalScale: 2,
      InputProps: { endAdornment: <InputAdornment position="end">%</InputAdornment> },
      show: true,
    },
    {
      label: 'Current Value',
      name: 'currentValue',
      component: RHFReactNumberFormat,
      decimalScale: 2,
      thousandSeparator: true,
      fixedDecimalScale: true,
      textAlign: 'right',
      prefix: true,
      minWidth: 150,
      width: 150,
      show: true,
    },
    { label: 'Collateral', name: 'collateral', component: RHFTextField, minWidth: 150, width: 150, show: true },
    { label: 'Secured or Not', name: 'securedOrNot', component: RHFAutocomplete, options: ['Secured', 'Unsecured'], minWidth: 150, width: 150, show: true },
    { label: 'Description', name: 'description', component: RHFTextField, minWidth: 150, width: 150, show: true },
    { label: '', name: 'action', component: RHFReactNumberFormat, minWidth: 50, width: 50, show: true },
  ];
};
